import React from 'react';
import { Flex, Image } from 'antd';
import { useLocation } from 'react-router-dom';
import logo from '../images/35a_logo.png'

const BasicLayout = ({ children }) => {
	const { pathname } = useLocation();
	const isRoot = pathname === '/';
	return (
		<div
			style={{
				backgroundColor: '#ffffff',
				minHeight: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column'
			}}
		>
			<Flex
				vertical
				align="flex-start"
				style={{
					maxWidth: 576,
					minHeight: '100vh',
					width: '100%'
				}}
			>
				{isRoot && (
					<header style={{
						padding: '20px 12px 16px',
						width: '100%'
					}}>
						<Flex align="center" justify="center" gap={10} wrap="nowrap" style={{ maxWidth: '100%' }}>
							<Image src={logo} height={28} preview={false} style={{ width: 'auto', flexShrink: 0 }} />
							<div
								style={{
									width: 1,
									height: 24,
									flexShrink: 0,
									backgroundColor: 'var(--eta-border-color)'
								}}
							/>
							<span
								style={{
									fontFamily: 'Muli, sans-serif',
									fontSize: 14,
									fontWeight: 700,
									color: 'var(--eta-color-theme)',
									whiteSpace: 'nowrap'
								}}
							>
								Campus Services Office
							</span>
						</Flex>
					</header>
				)}
				{children}
			</Flex>
		</div>
	);
};

export default BasicLayout;
